import { useTranslation } from "react-i18next";

import AsyncButton from "../../../../components/buttons/AsyncButton";
import { useOrderContext } from "../../../../contexts/OrderContext";
import useCreateOutboundDeliveryMutation from "../../../../hooks/graphql-hooks/mutations/useCreateOutboundDeliveryMutation";
import { useProgression } from "../../../../hooks/useProgression";
import { mapToCreateOutboundDeliveryInput } from "../../../../utils/mapperOutbound";
import OutboundSummary from "../../components/summary/OutboundSummary";
import BaseContent from "../BaseContent";
import "./SummaryScreen.scss";

interface SummaryScreenProps {
  setCreatedDeliveryId: (id: string) => void;
}

const SummaryScreen = (props: React.PropsWithChildren<SummaryScreenProps>) => {
  const { t } = useTranslation();
  const { savedProgress } = useOrderContext();
  const { goNext } = useProgression();

  const { setCreatedDeliveryId } = props;

  const [createMutation, { loading: loadingCreate }] =
    useCreateOutboundDeliveryMutation({
      dataAction: (id) => {
        setCreatedDeliveryId(id);
        goNext();
      },
    });

  const buttonText = "createOutboundDelivery";

  const sendCreateMutation = () => {
    const input = mapToCreateOutboundDeliveryInput(savedProgress);

    if (!input) return;

    createMutation({ variables: { input } }).catch(() => {});
  };

  const renderConfirmOrderButton = (
    <AsyncButton
      sendRequest={sendCreateMutation}
      loading={loadingCreate}
      disabled={loadingCreate}
    >
      {t(buttonText)}
    </AsyncButton>
  );

  return (
    <BaseContent
      screenName={"outboundSummaryScreen"}
      disableNext={false}
      saveProgress={() => {}} // no new data is entered in this screen so we don't need to save
      customProceedButton={renderConfirmOrderButton}
    >
      <OutboundSummary isConfirmation={false} />
    </BaseContent>
  );
};

export default SummaryScreen;
